import { EnrollmentPlanCSID } from "@/api/types";
import { useSelectedEnrollmentPlan } from "@/premium/hooks";
import { Dropdown } from "@/premium/themedComponents/Dropdown";
import { EnrollmentContext } from "@/state";
import { Icon } from "capitalrx-components-2.0/lib/general";
import { Shelf } from "capitalrx-components-2.0/lib/layout";
import { FC, useCallback, useContext, useMemo, useState } from "react";
import { useSearchParams } from "react-router";
import styled from "styled-components";

const DropdownLabel = styled.h1`
  font-family: ${(props) => props.theme.font};
  font-size: 28px;
  font-weight: 400;
  line-height: 37px;
  letter-spacing: 0px;
  text-align: left;
  margin: 0;
  margin-bottom: 4px;
  padding: 0;
  color: white !important;
`;

const DropdownItem = styled.h3`
  font-family: ${(props) => props.theme.font};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  padding: 8px;
  margin: 0;

  &:hover {
    background-color: #F1F1F1;
  }
`;


const ThemedIcon = styled(Icon)`
  path {
    fill: white !important;
  }
`;


const DropdownTitleShelf = styled(Shelf)`
  &:hover, &:active {
    background-color: rgb(95, 95, 95);
  }
  border-radius: 8px;
  padding: 8px;
`;


const DropdownTitle: FC<{ readonly title: string }> = ({ title }) => {
  return (
    <DropdownTitleShelf>
      <DropdownLabel>{title}</DropdownLabel>
      <ThemedIcon name="chevron-down" />
    </DropdownTitleShelf>
  );
};


export const PlanDropdown: FC = () => {
  const { enrollmentPlanCsid } = useSelectedEnrollmentPlan();
  const [state] = useContext(EnrollmentContext);
  const [isOpen, setIsOpen] = useState(false);
  const [_, setSearchParams] = useSearchParams();

  const dropdownTitle = useMemo(() => {
    return enrollmentPlanCsid?.display_name;
  }, [enrollmentPlanCsid]);

  const titlePressed = useCallback(() => {
    setIsOpen(!isOpen);
  }, [isOpen]);

  const blurred = useCallback(() => {
    setIsOpen(false);
  }, []);

  const itemSelected = useCallback((item: EnrollmentPlanCSID, setPlan: boolean) => {
    if (setPlan) {
      setSearchParams((prev) => {
        const params: { [key: string]: string } = {};
        prev.forEach((value, key) => {
          params[key] = value;
        });
        params["enrollmentPlan"] = item.id.toString();
        return params;
      });
    }
    setIsOpen(false);
  }, [setSearchParams]);

  return (
    <Dropdown isOpen={isOpen} onBlur={blurred} onClick={titlePressed} label={
      <DropdownTitle title={dropdownTitle} />
    }>
      {state.experienceData.plan_csids.map((ep) => {
        if (ep.id === enrollmentPlanCsid?.id) {
          return <DropdownItem key={ep.id} onClick={() => itemSelected(ep, false)}><b>{enrollmentPlanCsid?.display_name}</b></DropdownItem>;
        } else {
          return <DropdownItem key={ep.id} onClick={() => itemSelected(ep, true)}>{ep.display_name}</DropdownItem>;
        }
      })}
    </Dropdown>
  );
};
